import { useContext } from 'react';
import CustomPageTiles from '../components/CustomPageTiles';
import Header from '../components/Header';
import { UserContext } from '../App';

function MyClass() {
  const userCtx = useContext(UserContext);

  const isAuthenticated = () => {
    return userCtx.user != null;
  };

  return <>
    <Header />

	{ isAuthenticated() && <>
		<div id="tiles">
			<CustomPageTiles path="/myclass" />
		</div>
	</> }

	{ !isAuthenticated() && <>
		<div className="flex p-6">
			Neprihlásený!
		</div>
	</> }
  </>
}

export default MyClass;
